import { render, staticRenderFns } from "./MainFilters.vue?vue&type=template&id=315f2231&"
import script from "./MainFilters.vue?vue&type=script&lang=js&"
export * from "./MainFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports